import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GlobalConstants } from '../../global-constants';

@Injectable({
  providedIn: 'root'
})
export class QueryService {

  private apiUrl = GlobalConstants.urlServer + 'backend/api';

  constructor(private http: HttpClient) {}

  tokenHeaders() {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders()
      .set('Authorization', `Bearer ${token}`)
      .set('Content-Type', 'application/json');
    return headers;
  }

  // Query general
  query(query:any, accion:any, datos:any) {
    const body = {
      accion: accion,
      datos: datos,
      secret:GlobalConstants.secret
    };
    return this.http.post(`${this.apiUrl}/${query}.php`, body, { headers: this.tokenHeaders() });
  }

  // Enviar correo electrónico
  enviarMail(params:any) {
    const body = {
      accion: '',
      datos: params,
      secret:GlobalConstants.secret
    };
    return this.http.post(`${this.apiUrl}/email.php`, body, { headers: this.tokenHeaders() });
  }

}
